export const MESSAGE_FILTER_UPDATED = 'MESSAGE_FILTER_UPDATED'